import * as actions from 'src/tests-components/update-test/update-test.actions'
import { identity } from 'fp-ts/lib/function'
import { Lens } from 'monocle-ts'
import { none, Option, some, isNone } from 'fp-ts/lib/Option'
import { Reducer } from 'src/framework'
import { TestContent } from 'src/services/ds.service'

export type UpdateTestStatus = 'synched' | 'modified'

export interface UpdateTestState {
  testName: Option<string>
  test: Option<TestContent>
  status: UpdateTestStatus
}

export const testNameLense = Lens.fromProp<UpdateTestState>()('testName')
export const testLense = Lens.fromProp<UpdateTestState>()('test')
export const statusLense = Lens.fromProp<UpdateTestState>()('status')

export const initialUpdateTestState: UpdateTestState = {
  testName: none,
  test: none,
  status: 'synched'
}

export const sameState: (s: UpdateTestState) => UpdateTestState = identity

const canChangeTest = (state: UpdateTestState) => isNone(state.test) || state.status === 'synched'

export const updateTestReducer: Reducer<actions.UpdateTestActions, UpdateTestState> = actions.updateTestActions.match({
  UpdateTestLoadTestSuccess: action => (state: UpdateTestState) => testLense.set(some(action.test))(state),
  UpdateTestLoadTestFailure: _action => (state: UpdateTestState) => testLense.set(none)(state),
  UpdateTestSelectTest: action => (state: UpdateTestState) =>
    canChangeTest(state) ? statusLense.set('synched')(testNameLense.set(some(action.testName))(state)) : state,
  default: _action => sameState
})



// WEBPACK FOOTER //
// ./src/tests-components/update-test/update-test.reducer.ts